import script from "./OnboardingSlides.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingSlides.vue?vue&type=script&setup=true&lang=ts"

import "./OnboardingSlides.vue?vue&type=style&index=0&id=7515f68c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7515f68c"]])

export default __exports__